import { useModal } from '@/contexts/modal'
import AddIcons from '@/icons/AddIcons'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Button } from 'vnetwork-ui'

interface ICloneProps {
    contractID: number
}
const CreateProcessComponent: React.FC<ICloneProps> = ({ contractID = 0 }) => {
    const { t } = useTranslation()

    const { open, setModal } = useModal()

    return (
        <>
            <Button
                size="small"
                variant="contained"
                startIcon={<AddIcons />}
                onClick={() =>
                    setModal(
                        'ContractModals/CreateContractProcessModal/index',
                        {
                            contractID: contractID,
                        }
                    )
                }
                disabled={open}
            >
                {t('create-contract-process')}
            </Button>
        </>
    )
}

const CreateProcess = (props: ICloneProps) => {
    return <CreateProcessComponent {...props} />
}
export default CreateProcess
